import { render, staticRenderFns } from "./v-contentMainCatalog.vue?vue&type=template&id=375c44ca&"
import script from "./v-contentMainCatalog.vue?vue&type=script&lang=js&"
export * from "./v-contentMainCatalog.vue?vue&type=script&lang=js&"
import style0 from "./v-contentMainCatalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports